import { Box } from '@mui/material'
import { useTheme } from '@mui/styles'
import AppContext from 'app/appContext'
import Layout1Sidenav from 'app/EgretLayout/Layout1/Layout1Sidenav'
import { SidenavToggleBtn } from 'app/EgretLayout/Layout1/SidenavToggleBtn'
import { useSidebarMode } from 'app/EgretLayout/Layout1/useSidebarMode'
import PortalTranslationWarningBar from 'app/EgretLayout/PortalTranslationWarningBar'
import { FirstLoginFlowNavLayer } from 'app/views/first-login-flow/firstLoginFlowNavLayer'
import { PrivacyPolicy } from 'app/views/grants/grantsHome/PrivacyPolicy'
import { useRef } from 'react'
import { Scrollbars } from 'react-custom-scrollbars-2'
import { useSelector } from 'react-redux'
import { renderRoutes } from 'react-router-config'
import { classList } from 'utils'
import formsRoutes from '../../app/views/forms/formsRoutes'
import fundingRoutes from '../../app/views/funding/FundingRoutes'
import grantsRoutes from '../../app/views/grants/GrantsRoutes'
import dmahRoutes from '../../app/views/internal/DMAH/dmahRoutes'
import internalRoutes from '../../app/views/internal/InternalRoutes'
import { resourceInventoryRoutes } from '../../app/views/resources/ResourceRoutes'
import satRoutes from '../../app/views/self-assessment/SATRoutes'
import sessionRoutes from '../../app/views/sessions/SessionRoutes'
import surveyRoutes from '../../app/views/surveys/SurveyRoutes'
import vivreEnVilleRoutes from '../../app/views/vivre-en-ville/VivreEnVilleRoutes'
import Topbar from './Topbar'
import { usePreviousRoute } from './usePreviousRoute'

const routesList = [
  ...resourceInventoryRoutes,
  ...fundingRoutes,
  ...internalRoutes,
  ...grantsRoutes,
  ...sessionRoutes,
  ...formsRoutes,
  ...vivreEnVilleRoutes,
  ...dmahRoutes,
  ...satRoutes,
  ...surveyRoutes
]

const AppLayout = () => {
  const ref = useRef()
  const settings = useSelector(state => state.layout.settings)
  const { layout1Settings } = settings
  const theme = useTheme()
  const language = useSelector(state => state.user.language)

  const layoutClasses = {
    // [classes.layout]: true,
    [`${settings.activeLayout} sidenav-${layout1Settings.leftSidebar.mode} theme-${theme.palette.mode} flex`]: true
    // 'topbar-fixed': layout1Settings.topbar.fixed
  }

  const sidenavToggleRef = useRef(null)
  const layoutSidenavRef = useRef(null)
  const isToggleBtnTouchedRef = useRef(false)
  const contentWrapRef = useRef(null)
  const { mode, updateSidebarMode, allowClosing } = useSidebarMode()
  const previous = usePreviousRoute(routesList)

  return (
    <AppContext.Consumer>
      {({ routes }) => {
        return (
          <FirstLoginFlowNavLayer routes={routes} scrollbarContentRef={ref}>
            <div className={`${classList(layoutClasses)} flex`}>
              <Layout1Sidenav
                layoutSidenavRef={layoutSidenavRef}
                isToggleBtnTouchedRef={isToggleBtnTouchedRef}
                contentWrapRef={contentWrapRef}
                mode={mode}
              />
              <Box
                className='content-wrap position-relative'
                ref={contentWrapRef}
                sx={{ borderLeft: '1px solid #c0c0c0' }}
              >
                <Topbar />
                <Scrollbars
                  className='scrollable-content'
                  ref={ref}
                  style={{ backgroundColor: theme.palette.background.main }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      minHeight: '100%',
                      height: '100%'
                    }}
                  >

                    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                      <PortalTranslationWarningBar />
                      {renderRoutes(routes, {
                        scrollbarContentRef: ref,
                        previousPath: previous.path,
                        previousName: previous.name
                      })}
                      <div className='my-auto' />
                    </Box>
                    <Box sx={{ flexShrink: 0 }}>
                      {language && <PrivacyPolicy language={language} />}
                    </Box>
                  </Box>
                </Scrollbars>
                <SidenavToggleBtn
                  sidenavToggleRef={sidenavToggleRef}
                  layoutSidenavRef={layoutSidenavRef}
                  isToggleBtnTouchedRef={isToggleBtnTouchedRef}
                  mode={mode}
                  updateSidebarMode={updateSidebarMode}
                  allowClosing={allowClosing}
                />
              </Box>
            </div>
          </FirstLoginFlowNavLayer>
        )
      }}
    </AppContext.Consumer>
  )
}

export default AppLayout
